module.exports = __webpack_public_path__ + "media/images/edit-1fecd56bbd5d2fc15ecc5748c32b622d.svg";